import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const SubValue = styled.div`
  font-size: 12px;
  line-height: 130%;
  letter-spacing: 0.24px;
  color: ${Colors.GS600};
`
